import { render } from "./buy-order.vue?vue&type=template&id=68ac1058&scoped=true"
import script from "./buy-order.vue?vue&type=script&lang=js"
export * from "./buy-order.vue?vue&type=script&lang=js"

import "./buy-order.vue?vue&type=style&index=0&id=68ac1058&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ac1058"]])

export default __exports__